//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import { ConfigSystemParams, eSimApiPaths } from 'src/app/core/consts';
import { ConfigSystemService } from '../config-system/config-system-service';
import CustomStore from 'devextreme/data/custom_store';
import { EncryptionService } from '../../general/encryption-service';
import { environment } from 'src/environments/environment';
import { ExceptionsService } from '../../general/exceptions-service';
import { HttpClientService } from '../../general/http-client-service';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { Injectable } from '@angular/core';
import { lastValueFrom, map, Observable, of, switchMap } from 'rxjs';
import { ProductDTO } from 'src/app/core/models/system/product/product.dto';
import { StringResultDTO } from 'src/app/core/interfaces/general/string-result';

@Injectable({ providedIn: 'root' })

export class ProductsService {
  
  constructor(
    private configSystemService: ConfigSystemService,
    private encryptionService  : EncryptionService,
    private exceptionsService  : ExceptionsService,
    private httpClientService  : HttpClientService
  ) { }

  public getIdAndDescription(userId: number): Observable<IdAndDescriptionDTO[]> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>userId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const userIdEncSS=encResult.result;
                            
                            return this.httpClientService.get<ProductDTO[]>(environment.eSimApi +
                                                                            eSimApiPaths.Products +
                                                                            "?userIdEncSS=" + userIdEncSS)
                                   .pipe(
                                     map(x => {
                                       if (this.configSystemService.getValueAsBoolean(ConfigSystemParams.FormManageEsimDefaultProductsOnly, false)) {
                                         return x.filter(x => x.availableByDefault==true)
                                                .map(this.idAndDescriptionConverter);
                                                
                                       } else {
                                         return x.map(this.idAndDescriptionConverter);
                                       }
                                     })
                                   ); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getSupplierIdAndDescription(userId: number): Observable<IdAndDescriptionDTO[]> {
    try {
      return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>userId, true)
             .pipe(
                switchMap((encResult: StringResultDTO) => {
                            const userIdEncSS=encResult.result;
                            
                            return this.httpClientService.get<ProductDTO[]>(environment.eSimApi +
                                                                            eSimApiPaths.Products +
                                                                            "?userIdEncSS=" + userIdEncSS)
                                   .pipe(
                                     map(x => x.map(this.supplierProductIdAndDescriptionConverter))
                                   ); 
                         })
                  );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getAvailableIdAndDescription(sureSimOrderId: number=-1, companyId: number=-1): Observable<IdAndDescriptionDTO[]> {
    try {
      const baseUrl=environment.eSimApi
                    + eSimApiPaths.Products
                    + "/"
                    + eSimApiPaths.ProductsAvailableForSelection
                    + "?orderId=" + sureSimOrderId;

      if (companyId>0) {
        return this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>companyId, true)
               .pipe(
                 switchMap((encResult: StringResultDTO) => {
                             return this.httpClientService.get<ProductDTO[]>(baseUrl + "&companyIdEncSS=" + encResult.result)
                                    .pipe(map(x => x.map(this.idAndDescriptionConverter)));
                           })
               );
      }

      return this.httpClientService.get<ProductDTO[]>(baseUrl)
      .pipe(
        map(x => x.map(this.idAndDescriptionConverter))
      );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public refreshProducts(): Observable<any[]> {
    try {
      return this.httpClientService.get(environment.eSimApi + eSimApiPaths.Webbing + "/" + eSimApiPaths.WebbingProductsRefresh);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  private idAndDescriptionConverter(product: ProductDTO) {
    return {id: product.id, description: product.internalProductName};
  }

  private supplierProductIdAndDescriptionConverter(product: ProductDTO) {
    return {id: product.supplierProductId, description: product.internalProductName};
  }

  public idAndDescriptionLookupDataSource(userId: number): {} {
    try {
      return {
        store: new CustomStore({
          key: "id",
          loadMode: "raw",
          load: () => {
            return lastValueFrom(this.getIdAndDescription(userId));
          }
        }),
        sort: "description"
    };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return {};
    }
  }

  public supplierProductIdAndDescriptionLookupDataSource(userId: number): {} {
    try {
      return {
        store: new CustomStore({
          key: "id",
          loadMode: "raw",
          load: () => {
            return lastValueFrom(this.getSupplierIdAndDescription(userId));
          }
        }),
        sort: "description"
    };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return {};
    }
  }
}
